module.exports = __webpack_public_path__ + "img/Ymanci_Logo_v2.f61b7c78.svg";